import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ReportsData } from './reports-data';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Filters } from './filters-data';

@Injectable({
  providedIn: 'root'
})

export class BoardsService {

  constructor(private httpClient: HttpClient) { }

  currentYear = new Date().getFullYear() + '';

  sales = 'All'
  region = 'All'
  sector = 'All'
  status = 'null'
  public quarter: string[] = ['null'];
  public year: string[] = [this.currentYear];
  public renewable: boolean = false;
  public partner: boolean = false;
  public sbmchannel: string = 'All';
  public productKind: string[] = ['SWG', 'STG']
  gstatus = 'All';

  public setFilters(region: string, sales: string, sector: string, status: string, year: string[], quarter: any[], productKind: string[], gstatus: string, renewable: boolean, sbmchannel: string, partnerFilter: boolean) {
    this.sales = sales;
    this.region = region;
    this.sector = sector;
    this.status = status;
    this.quarter = quarter;
    this.year = year;
    this.renewable = renewable;
    this.sbmchannel = sbmchannel;
    this.productKind = productKind;
    this.gstatus = gstatus;
    this.partner = partnerFilter;

    // console.log("setFilters service called......");
    // console.log("region:" + this.region);
    // console.log("this.sales:" + this.sales);
    // console.log("this.sector:" + this.sector);
    // console.log("this.status:" + this.status);
    // console.log("this.year:" + this.year);
    // console.log("this.quarter:" + this.quarter);
    // console.log("this.productKind:" + this.productKind);
    // console.log("gstatus:" + this.gstatus);
    // console.log("this.renewable:" + this.renewable);
    // console.log("this.sbmchannel:" + this.sbmchannel);
  }

  getFilters(): Filters {

    let filters: Filters = new Filters();

    filters.sales = this.sales;
    filters.region = this.region;
    filters.sector = this.sector;
    filters.status = this.status;
    filters.quarter = this.quarter;
    filters.year = this.year;
    filters.renewable = this.renewable;
    filters.productKind = this.productKind;
    filters.gstatus = this.gstatus;
    filters.sbmchannel = this.sbmchannel;
    filters.partner = this.partner;

    return filters;
  }

  resetFilters() {
    // console.log("reset boards service called......");
    this.sales = 'All'
    this.region = 'All'
    this.sector = 'All'
    this.status = 'All'
    this.quarter = null
    this.year = [this.currentYear]
    this.renewable = false;
    this.productKind = ['SWG', 'STG']
    this.gstatus = 'All'
    this.sbmchannel = 'All'
    this.partner = false;
  }
  public callBriefService(): Observable<ReportsData> {
    // console.log(sessionStorage.getItem('loginUserName'));
    //console.log(sessionStorage.getItem('loginPassword'));

    // console.log("brief service called......");
    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
    return this.httpClient.get<ReportsData>('/api/v1/opportunity/opportunitiesBrief/' + this.region + '/' + this.sales + '/' + this.sector + '/' + this.status + '/' + this.year + '/' + this.quarter + '/' + this.gstatus + '/' + this.renewable + '/' + this.sbmchannel + '/' + this.partner, { headers })
      .pipe(catchError(this.errorHandler));
  }

  callTopFiveActiveOpportunities(): Observable<ReportsData[]> {
    // console.log("callTopFiveActiveOpportunities service called......");
    // console.log("region:" + this.region);
    // console.log("this.sales:" + this.sales);
    // console.log("this.sector:" + this.sector);
    // console.log("this.status:" + this.status);
    // console.log("this.year:" + this.year);
    // console.log("this.quarter:" + this.quarter);
    // console.log("this.productKind:" + this.productKind);
    // console.log("gstatus:" + this.gstatus);
    // console.log("this.renewable:" + this.renewable);
    // console.log("this.sbmchannel:" + this.sbmchannel);
    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
    return this.httpClient.get<ReportsData[]>('/api/v1/opportunity/topFiveActiveOpportunities/' + this.region + '/' + this.sales + '/' + this.sector + '/' + this.status + '/' + this.year + '/' + this.quarter + '/' + this.productKind + '/' + this.gstatus + '/' + this.renewable + '/' + this.sbmchannel + '/' + this.partner, { headers })
      .pipe(catchError(this.errorHandler));
  }

  callfillPiplineByOpportunitiesStatus(): Observable<ReportsData[]> {
    // console.log("callfillPiplineByOpportunitiesStatus service called......");
    // console.log("region:" + this.region);
    // console.log("this.sales:" + this.sales);
    // console.log("this.sector:" + this.sector);
    // console.log("this.status:" + this.status);
    // console.log("this.year:" + this.year);
    // console.log("this.quarter:" + this.quarter);
    // console.log("this.productKind:" + this.productKind);
    // console.log("gstatus:" + this.gstatus);
    // console.log("this.renewable:" + this.renewable);
    // console.log("this.sbmchannel:" + this.sbmchannel);
    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
    return this.httpClient.get<ReportsData[]>('/api/v1/status/piplineByOpportunitiesStatus/' + this.region + '/' + this.sales + '/' + this.sector + '/' + this.status + '/' + this.year + '/' + this.quarter + '/' + this.productKind + '/' + this.gstatus + '/' + this.renewable + '/' + this.sbmchannel + '/' + this.partner, { headers })
      .pipe(catchError(this.errorHandler));
  }

  errorHandler(error: HttpErrorResponse) {
    // console.log(error.message);
    return throwError(error.message || 'Server Error');

  }

  callfillSSSSummary(): Observable<ReportsData> {
    /*console.log("callfillSSSSummary service called......");
    console.log("region:" + region);
    console.log("this.sales:" + this.sales);
    console.log("this.sector:" + this.sector);
    console.log("this.status:" + this.status);
    console.log("this.year:" + this.year);
    console.log("this.quarter:" + this.quarter);
    console.log("this.productKind:" + this.productKind);
    console.log("gstatus:" + gstatus);*/

    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
    let userEmail = sessionStorage.getItem('loginUserName');

    //console.log('/api/v1/opportunity/sssSummary/' + region + '/' + this.sales + '/' + this.productKind + '/' + this.sector + '/' + this.status + '/' + this.year + '/' + this.quarter + '/' + gstatus + '/' + this.renewable  + '/' + this.sbmchannel);
    return this.httpClient.get<ReportsData>('/api/v1/opportunity/sssSummary/' + this.region + '/' + this.sales + '/' + this.productKind + '/' + this.sector + '/' + this.status + '/' + this.year + '/' + this.quarter + '/' + this.gstatus + '/' + this.renewable + '/' + this.sbmchannel + '/' + this.partner + '/' + userEmail, { headers })
      .pipe(catchError(this.errorHandler));
  }

  callSectorSummary(): Observable<ReportsData[]> {
    /*console.log("callfillSSSSummary service called......");
    console.log("region:" + region);
    console.log("this.sales:" + this.sales);
    console.log("this.sector:" + this.sector);
    console.log("this.status:" + this.status);
    console.log("this.year:" + this.year);
    console.log("this.quarter:" + this.quarter);
    console.log("this.productKind:" + this.productKind);
    console.log("this.gstatus:" + this.gstatus);*/

    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
    //console.log('/api/v1/opportunity/sssSummary/' + region + '/' + this.sales + '/' + this.productKind + '/' + this.sector + '/' + this.status + '/' + this.year + '/' + this.quarter + '/' + this.gstatus + '/' + this.renewable  + '/' + this.sbmchannel);
    return this.httpClient.get<ReportsData[]>('/api/v1/opportunity/sectorsSummary/' + this.region + '/' + this.sales + '/' + this.productKind + '/' + this.sector + '/' + this.status + '/' + this.year + '/' + this.quarter + '/' + this.gstatus + '/' + this.renewable + '/' + this.sbmchannel + '/' + this.partner, { headers })
      .pipe(catchError(this.errorHandler));
  }

  callBrandsSummary(): Observable<ReportsData[]> {
    /*console.log("callfillSSSSummary service called......");
    console.log("region:" + region);
    console.log("this.sales:" + this.sales);
    console.log("this.sector:" + this.sector);
    console.log("this.status:" + this.status);
    console.log("this.year:" + this.year);
    console.log("this.quarter:" + this.quarter);
    console.log("this.productKind:" + this.productKind);
    console.log("this.gstatus:" + this.gstatus);*/

    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
    //console.log('/api/v1/opportunity/sssSummary/' + region + '/' + this.sales + '/' + this.productKind + '/' + this.sector + '/' + this.status + '/' + this.year + '/' + this.quarter + '/' + this.gstatus + '/' + this.renewable  + '/' + this.sbmchannel);
    return this.httpClient.get<ReportsData[]>('/api/v1/opportunity/brandsSummary/' + this.region + '/' + this.sales + '/' + this.productKind + '/' + this.sector + '/' + this.status + '/' + this.year + '/' + this.quarter + '/' + this.gstatus + '/' + this.renewable + '/' + this.sbmchannel + '/' + this.partner, { headers })
      .pipe(catchError(this.errorHandler));
  }

  callTechLeadsOpportunitiesCount(): Observable<any[]> {
    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
    return this.httpClient.get<any[]>('/api/v1/tech-leads/opportunities-count/', { headers })
      .pipe(catchError(this.errorHandler));
  }

  getOpportunities(id: string): Observable<string[]> {
    const url = `/api/v1/tech-leads/${id}/names`;
    return this.httpClient.get<string[]>(url);
  }

}
